<template>
  <section class="guideline-section">
    <div class="container-fluid">

      <!-- Header -->
      <div class="gl-header">
        <div class="gl-header-text">
          <span class="gl-badge">ফ্রি রিসোর্স</span>
          <h2>বিষয়ভিত্তিক গাইডলাইন</h2>
          <p>বিসিএস ৩৫–৫০ পর্যন্ত টপিকভিত্তিক প্রশ্ন বিশ্লেষণ ও হিটম্যাপ — সম্পূর্ণ ফ্রি</p>
          <a class="gl-view-all" @click="goToAllGuidelines">
            সব গাইডলাইন দেখুন →
          </a>
        </div>
      </div>

      <!-- Cards -->
      <div class="gl-grid">
        <div v-for="(guide, index) in guidelineList" :key="index"
             class="gl-card" @click="goToGuideline(guide)">
          <div class="gl-card-img">
            <img :src="guide.image" :alt="guide.title" />
            <span class="gl-mark">{{ guide.marks }}</span>
          </div>
          <div class="gl-card-body">
            <div class="gl-tags">
              <span class="gl-tag" v-for="t in guide.tags" :key="t">{{ t }}</span>
            </div>
            <h3>{{ guide.title }}</h3>
            <p>{{ guide.desc }}</p>
            <span class="gl-link">
              গাইডলাইন দেখুন
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M13.267 4.209a.75.75 0 0 0-1.06 1.06l5.58 5.58H3.75a.75.75 0 0 0 0 1.5h14.037l-5.58 5.58a.75.75 0 1 0 1.06 1.06l6.868-6.867a.75.75 0 0 0 0-1.062l-6.868-6.851z" fill="currentColor"/>
              </svg>
            </span>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import router from "@/router";
import { URLs } from "@/static";
import { guidelines } from "@/components/WelcomePages/guidelinesData";

export default defineComponent({
  setup() {
    const guidelineList = guidelines;

    const goToGuideline = (guide) => router.push({ name: guide.route });
    const goToAllGuidelines = () => router.push({ name: URLs.ROUTE_GUIDELINES_NAME });

    return { guidelineList, goToGuideline, goToAllGuidelines };
  },
});
</script>

<style scoped>
/* Section */
.guideline-section {
  background: #12142e;
  padding: 80px 0 64px;
  margin-top: 48px;
  border-top: 4px solid #0095FF;
}

/* Header */
.gl-header {
  text-align: center; margin-bottom: 40px;
}
.gl-badge {
  display: inline-block; font-size: 0.7rem; font-weight: 700;
  letter-spacing: 0.07em; text-transform: uppercase;
  color: #7CC6FF; background: rgba(0,149,255,0.15);
  border: 1px solid rgba(0,149,255,0.32);
  padding: 3px 12px; border-radius: 999px; margin-bottom: 14px;
}
.gl-header-text h2 {
  font-size: 1.8rem; font-weight: 800; color: #fff; margin: 0 0 8px 0;
}
.gl-header-text p { font-size: 0.9rem; color: #94a3b8; margin: 0 0 20px 0; }
.gl-view-all {
  display: inline-flex; align-items: center;
  font-size: 0.85rem; font-weight: 700; color: #38B6FF;
  cursor: pointer; white-space: nowrap;
  border-bottom: 1px solid rgba(0,149,255,0.4);
  padding-bottom: 2px; transition: color 0.18s;
}
.gl-view-all:hover { color: #7CC6FF; }

/* Grid */
.gl-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;
}
@media(max-width: 992px) { .gl-grid { grid-template-columns: repeat(2, 1fr); } }
@media(max-width: 560px)  { .gl-grid { grid-template-columns: 1fr; } }

/* Card */
.gl-card {
  background: #1e2048; border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px; overflow: hidden; cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
  display: flex; flex-direction: column;
}
.gl-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 32px rgba(0,0,0,0.4);
  border-color: rgba(0,149,255,0.45);
}

/* Image */
.gl-card-img { position: relative; overflow: hidden; flex-shrink: 0; }
.gl-card-img img { width: 100%; height: auto; display: block; }
.gl-mark {
  position: absolute; top: 10px; right: 10px;
  background: #191B47; color: #38B6FF;
  font-size: 0.7rem; font-weight: 800;
  padding: 3px 10px; border-radius: 999px;
}

/* Body */
.gl-card-body { padding: 16px 18px 18px; flex: 1; display: flex; flex-direction: column; }
.gl-tags { display: flex; flex-wrap: wrap; gap: 5px; margin-bottom: 10px; }
.gl-tag {
  font-size: 0.66rem; font-weight: 600; color: #bfe3ff;
  background: rgba(0,149,255,0.18); border: 1px solid rgba(0,149,255,0.3);
  padding: 2px 7px; border-radius: 4px;
}
.gl-card-body h3 {
  font-size: 0.95rem; font-weight: 700; color: #fff;
  margin: 0 0 8px 0; text-align: left; line-height: 1.4;
}
.gl-card-body p {
  font-size: 0.8rem; color: #94a3b8; line-height: 1.6;
  margin: 0 0 14px 0; text-align: left; flex: 1;
}
.gl-link {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 0.8rem; font-weight: 700; color: #38B6FF;
  margin-top: auto;
}
</style>
